var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multiple-choice"},_vm._l((_vm.variants),function(i,k){return _c('div',{key:k+'_'+i.id,staticClass:"multiple-choice__item",on:{"!click":function($event){return _vm.handleVariantClick(i.id)}}},[_c('v-simple-checkbox',{style:({
        alignSelf: 'flex-start',
        paddingTop: '3px'
      }),attrs:{"value":_vm.answer.includes(i.id),"disabled":_vm.disabled,"color":"#EF7F1A","ripple":false}}),_c('span',{staticClass:"multiple-choice__item__text",class:{
        'multiple-choice__item__text--active': _vm.answer.includes(i.id),
      }},[_vm._v(_vm._s(i.value))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }